var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"ContentSimpleTable"},_vm._l((_vm.data),function(row){return _c('tr',{key:row.label},[_c('td',[_vm._v(_vm._s(row.label))]),_c('td',[_vm._v(_vm._s(row.value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }